import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUsdt = function SvgUsdt(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#50AF95",
        d: "M118.191 74.514c-8.013 32.143-40.569 51.705-72.716 43.69C13.342 110.19-6.22 77.632 1.797 45.492 9.807 13.345 42.363-6.218 74.5 1.795c32.144 8.014 51.705 40.575 43.691 72.72"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M67.593 66.802c-.425.032-2.617.163-7.506.163-3.89 0-6.65-.117-7.62-.163-15.028-.66-26.246-3.277-26.246-6.41s11.218-5.745 26.247-6.416v10.22c.983.071 3.797.237 7.686.237 4.667 0 7.004-.194 7.424-.233V53.983c14.998.668 26.191 3.284 26.191 6.41 0 3.125-11.19 5.741-26.19 6.406zm0-13.876v-9.147h20.93V29.832H31.537v13.947h20.926v9.143c-17.009.781-29.8 4.15-29.8 8.188s12.791 7.403 29.8 8.188v29.31H67.59v-29.32c16.97-.782 29.74-4.147 29.74-8.181s-12.76-7.4-29.74-8.185z",
        clipRule: "evenodd"
    })));
};

export { SvgUsdt as ReactComponent };
//# sourceMappingURL=USDT.svg.es.js.map
